<template>
  <div class="accountSetting pl-xl-4">
    <h3 class="border-bottom pb-3 medium mb-4">Personal Information</h3>
    <div class="profileInfo">
      <!-- <h6>Photo</h6>
			<div class="d-flex align-items-center">
				<img src="../../../../../static/website/images/avater.png" align="avater" title="Profile Photo">
				<a href="javascript:void(0)" class="cap_btn-b small">Change</a>
				<a href="javascript:void(0)" class="small red">Remove</a>
			</div> -->
      <ul class="listProfile mt-4">
        <li class="fullRow">
          <strong>First Name</strong>
          <span>{{
            profileInfo.firstname != null && profileInfo.firstname != ""
              ? profileInfo.firstname
              : "-"
          }}</span>
        </li>
        <li class="fullRow">
          <strong>Last Name</strong>
          <span>{{
            profileInfo.lastname != null && profileInfo.lastname != ""
              ? profileInfo.lastname
              : "-"
          }}</span>
        </li>
        <li class="fullRow">
          <strong>Email Address</strong>
          <span>{{
            profileInfo.email != null && profileInfo.email != ""
              ? profileInfo.email
              : "-"
          }}</span>
        </li>
        <!-- <li class="fullRow d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <strong> Phone</strong>
            <span>{{
              get_user.mobile_no != null && get_user.mobile_no != ""
                ? get_user.mobile_no
                : "-"
            }}</span>
          </div>
          <span
            class="editInfo editNumber d-flex align-items-center justify-content-center"
            @click="editNumber = !editNumber"
            v-if="parseInt(get_user.tier) > 2"
          >
            <feather type="edit"></feather>
          </span>
        </li> -->
        <li class="fullRow">
          <strong>Date of birth</strong>
          <span>{{ profileInfo.dob | moment("Do MMMM YYYY") }}</span>
        </li>
        <li class="fullRow" v-if="parseInt(get_user.lead_type) == 1">
          <strong>Job Title</strong>
          <span>{{
            profileInfo.job_title != null && profileInfo.job_title != ""
              ? profileInfo.job_title
              : "-"
          }}</span>
        </li>
        <li class="fullRow">
          <strong>Address</strong>
          <span>{{ profileInfo.address1 ? profileInfo.address1 : "-" }}</span>
        </li>
        <li class="fullRow">
          <strong> City or Town</strong>
          <span>{{
            profileInfo.city != null && profileInfo.city != ""
              ? profileInfo.city
              : "-"
          }}</span>
        </li>
        <li class="fullRow">
          <strong> Post Code</strong>
          <span>{{
            profileInfo.post_code
              ? profileInfo.post_code
              : profileInfo.zip_code
              ? profileInfo.zip_code
              : "-"
          }}</span>
        </li>
        <li class="fullRow">
          <strong>Country of Residence</strong>
          <span>{{
            profileInfo.residence_country
              ? $env_var.countriesList[profileInfo.residence_country]
                ? $env_var.countriesList[profileInfo.residence_country].name
                : profileInfo.residence_country
              : "-"
          }}</span>
        </li>
        <li class="fullRow">
          <strong>Nationality</strong>
          <span>{{
            profileInfo.nationality
              ? $env_var.countriesList[profileInfo.nationality]
                ? $env_var.countriesList[profileInfo.nationality].name
                : profileInfo.nationality
              : "-"
          }}</span>
        </li>
      </ul>
      <p class="themecolor f-14 medium">
        This account was created on
        {{
          get_user.profile && get_user.profile.created
            ? formatDate(get_user.profile.created)
            : ""
        }}.
      </p>
      <!-- <p class="themecolor f-14 medium">This account was created on {{ get_user.profile && get_user.profile.created ? get_user.profile.created : ''}}. <a class="secondary" href="javascript:void(0)">Click here</a> to change your legal name by verifying an ID document.</p>
            <div class="buttons d-flex align-items-center justify-content-end border-top pt-4 mt-4">
            	<a href="javascript:void(0)" class="cap_btn-b mr-3 min-auto">Cancel</a>
            	<a href="javascript:void(0)" class="cap_btn">Save</a>
            </div> -->
    </div>
  </div>
</template>

<script>
import { registerStepsMixins } from "@/plugins/registerSteps";
import moment from "moment";

export default {
  name: "accountprofile",
  mixins: [registerStepsMixins],
  data() {
    return {
      notification_msg: "",
      notification_type: "",
      submitted: false,
      fname: "",
      mName: "",
      lname: "",
      dob: "",
      address: "",
      city: "",
      state: "",
      country: "",
      area_code: "",
      acc_type: "",
      OrganizationType: {
        0: "Company",
        1: "Self Managed Super Fund",
        2: "Discretionary/Unit Trust",
        3: "Others",
      },
    };
  },
  components: {
    // editAddress,
    // editNumber
  },

  methods: {
    create_image(url, name) {
      var stx = this.stxx;
      var link = document.createElement("a");
      link.download = name;
      link.href = url;
      link.click();
    },
    formatDate(date) {
      return moment(date).format("Do MMM, YYYY");
    },
    ChangeTab(val) {
      this.tab = val;
      // this.editAddress = false
      // this.editNumber = false
      this.pageLoader = false;
    },
    Submit() {
      const _that = this;
      _that.submitted = true;
      _that.$validator.validate().then((valid) => {
        if (valid) {
          let input_json = {
            globalParams: {
              f_name: _that.fname,
              m_name: _that.mName,
              l_name: _that.lname,
              dob: _that.dob,
              Address: _that.address,
              City: _that.city,
              State: _that.state,
              Country: _that.country,
              Areacode: _that.area_code,
              Acc_type: _that.acc_type,
            },
            localParams: {
              parameter: _that,
            },
          };
        }
      });
    },
  },
  created() {
    this.pageName("Account Profile");
    this._runGetProfileInfo({
      globalParams: {},
      localParams: {
        parameter: this,
      },
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/settings/files/account.vue